import useI18n from "@i18n";
import { Stack, Typography } from "@mui/material";

interface ITimeDisplay {
  weeks?: number;
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
}

const TimeDisplay = ({ weeks = 0, days = 0, hours = 0, minutes = 0, seconds = 0 }: ITimeDisplay) => {
  const { i18n } = useI18n();

  const allZero = weeks === 0 && days === 0 && hours === 0 && minutes === 0 && seconds === 0;

  return (
    <Stack direction="row" alignItems="baseline" spacing={1}>
      {allZero ? (
        <Stack direction="row" alignItems="baseline" gap={1}>
          <Typography variant="text3xl700" color="text.primary" textAlign="left">
            {days}
          </Typography>
          <Typography variant="text1xl400" color="text.secondary">
            {i18n("progress.training.streak.days")}
          </Typography>
        </Stack>
      ) : (
        <>
          {weeks > 0 && (
            <Stack direction="row" alignItems="baseline" gap={1}>
              <Typography variant="text3xl700" color="text.primary" textAlign="left">
                {weeks}
              </Typography>
              <Typography variant="text1xl400" color="text.secondary">
                {i18n("progress.training.streak.weeks")}
              </Typography>
            </Stack>
          )}
          {days > 0 && (
            <Stack direction="row" alignItems="baseline" gap={1}>
              <Typography variant="text3xl700" color="text.primary" textAlign="left">
                {days}
              </Typography>
              <Typography variant="text1xl400" color="text.secondary">
                {i18n("progress.training.streak.days")}
              </Typography>
            </Stack>
          )}
          {hours > 0 && (
            <Stack direction="row" alignItems="baseline" gap={1}>
              <Typography variant="text3xl700" color="text.primary" textAlign="left">
                {hours}
              </Typography>
              <Typography variant="text1xl400" color="text.secondary">
                {i18n("hours-extra-short-capitalized")}
              </Typography>
            </Stack>
          )}
          {minutes > 0 && (
            <Stack direction="row" alignItems="baseline" gap={1}>
              <Typography variant="text3xl700" color="text.primary" textAlign="left">
                {minutes}
              </Typography>
              <Typography variant="text1xl400" color="text.secondary">
                {i18n("minutes-extra-short-capitalized")}
              </Typography>
            </Stack>
          )}
          {seconds > 0 && (
            <Stack direction="row" alignItems="baseline" gap={1}>
              <Typography variant="text3xl700" color="text.primary" textAlign="left">
                {seconds}
              </Typography>
              <Typography variant="text1xl400" color="text.secondary">
                {i18n("seconds-extra-short-capitalized")}
              </Typography>
            </Stack>
          )}
        </>
      )}
    </Stack>
  );
};

export default TimeDisplay;
